import { render } from "./ProductRegistrationProgressBar.vue?vue&type=template&id=58a2c032"
import script from "./ProductRegistrationProgressBar.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__